angular.module("picmonic-common")
    .factory("SchoolDataService", [function(){
        return {
            market_id: null,
            schools: []
        }
    }]);
